import { render } from "./bestFootwearCombinationTable.vue?vue&type=template&id=1e0f1fec&scoped=true&ts=true"
import script from "./bestFootwearCombinationTable.vue?vue&type=script&lang=ts"
export * from "./bestFootwearCombinationTable.vue?vue&type=script&lang=ts"

import "./bestFootwearCombinationTable.vue?vue&type=style&index=0&id=1e0f1fec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0f1fec"]])

export default __exports__